import { Link } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { MessageBubble } from "@/components/crm/conversations/MessageBubble";
import { ChannelBadge, Panel } from "@/components/crm/Badges";

export const ConversationsPanel = ({ conversations, onChanged }) => (
  <Panel title="Conversaciones" icon={MessagesSquare} testid="lead-conversations-panel">
    {conversations.length === 0 ? (
      <p className="rounded-xl bg-[#F5F7FA] p-5 text-sm text-slate-500" data-testid="conversations-empty">
        Las conversaciones se sincronizarán con la plataforma de mensajería cuando la integración esté activa.
      </p>
    ) : (
      <div className="space-y-6">
        {conversations.map((c) => (
          <div key={c.id} data-testid={`conversation-${c.id}`}>
            <div className="mb-3 flex items-center gap-2 text-xs text-slate-500">
              <ChannelBadge channel={c.channel} /> <span>{c.status}</span>
              <Link to={`/crm/conversaciones/${c.id}`} className="ml-auto font-semibold text-[#1E6FD9]" data-testid={`open-conversation-${c.id}`}>Abrir en bandeja</Link>
            </div>
            <div className="space-y-2.5">
              {c.messages.map((m) => <MessageBubble key={m.id} m={m} conversationId={c.id} onRetried={onChanged} />)}
            </div>
          </div>
        ))}
      </div>
    )}
  </Panel>
);
